// routes/Login.jsx

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setAdminKey, clearAdminKey } from '../api/getProducts';

const ADMIN_USERNAME = 'chi26fu';
const ADMIN_PASSWORD = 'chi26fu';
const AUTH_KEY = 'chikwafu_admin_auth';

// This must match the ADMIN_API_KEY secret set on the Worker
// (`wrangler secret put ADMIN_API_KEY`). It's sent as a Bearer token on
// every write request so the Worker knows the request came from an
// authenticated admin session, not just anyone hitting the API.
// Keep this in an env var in real deployments rather than hardcoding it,
// e.g. import.meta.env.VITE_ADMIN_API_KEY.
const ADMIN_API_KEY = process.env.REACT_APP_ADMIN_API_KEY || 'change-this-shared-secret';

export function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  function handleSubmit(e) {
    e.preventDefault();

    if (username === ADMIN_USERNAME && password === ADMIN_PASSWORD) {
      localStorage.setItem(AUTH_KEY, 'true');
      setAdminKey(ADMIN_API_KEY);
      setError('');
      navigate('/admin');
    } else {
      setError('Invalid username or password.');
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg px-4">
      <div className="w-full max-w-sm rounded-2xl border border-white/10 bg-card p-8">
        <h1 className="mb-1 text-xl font-black text-text">Admin Login</h1>
        <p className="mb-6 text-sm text-text-muted">Sign in to manage products.</p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-text-dim">
              Username
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              className="w-full rounded-lg border border-white/10 bg-bg3 px-3 py-2 text-sm text-text outline-none focus:border-accent"
              required
            />
          </div>

          <div>
            <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-text-dim">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              className="w-full rounded-lg border border-white/10 bg-bg3 px-3 py-2 text-sm text-text outline-none focus:border-accent"
              required
            />
          </div>

          {error && <p className="text-xs font-bold text-warning">{error}</p>}

          <button
            type="submit"
            className="mt-2 rounded-full bg-accent px-4 py-2.5 text-sm font-extrabold text-black transition-colors hover:bg-accent/90"
          >
            Sign in
          </button>
        </form>
      </div>
    </div>
  );
}

export function isAdminAuthenticated() {
  return localStorage.getItem(AUTH_KEY) === 'true';
}

export function adminLogout() {
  localStorage.removeItem(AUTH_KEY);
  clearAdminKey();
}
